import html2canvas from 'html2canvas';

/**
 * canvas截图
 * @param {*} id 对应div的id
 * @returns 
 */
export function shootImg (id) {
  return new Promise((resolve, reject) => {
    const captureElement = document.getElementById(id);

    html2canvas(captureElement, { 
      useCORS: true, // 如果使用了跨域图片，需要设置此参数
      scale: 1 // 可以设置缩放比例
    }).then(canvas => {
        // 将canvas转换为图片
        const imgData = canvas.toDataURL('image/png');
        // // 创建一个a标签用于下载
        // const link = document.createElement('a');
        // link.href = imgData;
        // link.download = 'screenshot.png';
        // link.click();
        
        // 将base64数据转换为Blob
        const byteString = atob(imgData.split(',')[1]);
        const mimeString = imgData.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });
  
        resolve(blob)
    }).catch(e => {
      reject(e)
    })
  });
}